import { Link } from 'react-router-dom';

export function MidCTA() {
  return (
    <section className="py-14 md:py-18 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          Ready to Start Shopping?
        </h2>
        <p className="text-primary-100 text-sm md:text-base mb-7 max-w-xl mx-auto">
          Join thousands of smart shoppers using the CSSBuy Spreadsheet. Free access, daily updates, and verified products await.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-primary-600 text-sm font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Browse Verified Sellers
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-600 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-700 transition-all border border-primary-400 whitespace-nowrap cursor-pointer"
          >
            cssbuy sheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export function ArticlePreview() {
  const articles = [
    { title: 'CSSBuy Spreadsheet Ultimate Guide: Everything You Need to Know', desc: 'A comprehensive walkthrough of how to use the CSSBuy Spreadsheet to find the best products, avoid common mistakes, and shop like a pro.', category: 'Guide', readTime: '12 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
    { title: 'Best CSSBuy Spreadsheet Tips for Finding Hidden Gems', desc: 'Discover advanced techniques for uncovering the best deals and rarest finds hidden within the spreadsheet categories.', category: 'Tips', readTime: '8 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
    { title: 'How to Verify Sellers Using the CSSBuy Spreadsheet', desc: 'Learn the key indicators of trustworthy sellers including rating analysis, review patterns, and community reputation signals.', category: 'Safety', readTime: '7 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
    { title: 'CSSBuy Spreadsheet QC Photo Guide for Beginners', desc: 'Master the art of reading Quality Control photos to ensure you always receive exactly what you expect from your orders.', category: 'Guide', readTime: '10 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
    { title: 'Top 10 Brands to Explore in the CSSBuy Spreadsheet', desc: 'From Nike to Gucci, explore the most popular brands available and learn which ones offer the best value through the spreadsheet.', category: 'Brands', readTime: '6 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
    { title: 'CSSBuy Spreadsheet Shipping Guide: US, UK, and EU', desc: 'Everything about international shipping options, customs handling, and delivery timelines for major destinations.', category: 'Guide', readTime: '9 min', href: '/articles/cssbuy-spreadsheet-ultimate-guide' },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-wider bg-secondary-50 px-3 py-1 rounded-full mb-4">Read</span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              Latest <strong>CSSBuy Spreadsheet</strong> Articles
            </h2>
          </div>
          <Link
            to="/articles/cssbuy-spreadsheet-ultimate-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            View All Articles
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article, i) => (
            <Link
              key={i}
              to={article.href}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="text-xs font-semibold text-secondary-600 bg-secondary-50 px-2.5 py-1 rounded-full">{article.category}</span>
                <span className="text-xs text-foreground-400">{article.readTime} read</span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{article.desc}</p>
              <div className="flex items-center gap-1.5 mt-4 text-xs font-medium text-primary-600">
                Read More
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FooterCTA() {
  return (
    <section className="py-16 md:py-20 bg-background-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Flowing%20organic%20abstract%20composition%20with%20sweeping%20ribbon%20like%20forms%20in%20soft%20sage%20green%20cream%20and%20warm%20peach%20tones%20interwoven%20with%20delicate%20circular%20elements%20and%20scattered%20geometric%20dots%20arrangement%20evoking%20a%20gentle%20breeze%20through%20a%20modern%20botanical%20garden%20soft%20diffused%20lighting%20with%20subtle%20gradient%20transitions%20creating%20a%20serene%20peaceful%20atmosphere%20clean%20Scandinavian%20influenced%20graphic%20design%20aesthetic%20with%20layered%20translucent%20shapes%20and%20airy%20open%20space%20ideal%20for%20sophisticated%20lifestyle%20brand%20backdrop&width=1920&height=600&seq=cta-v3-flow-j92p&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          Visit Our Main Website Today
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 max-w-xl mx-auto">
          The CSSBuy Spreadsheet is constantly growing with new products and categories. Head over to our main platform and start discovering amazing deals.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore the Latest Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 text-background-50 text-base font-semibold rounded-full hover:bg-background-50/20 border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}